const value = {
  metrics: {
    averageProgress: {
      label: 'Company progress',
    },
    averageProgressProject: {
      label: 'Average project progress',
    },
    averageScore: {
      label: 'Average score',
    },
    activeUsers: {
      label: 'Active users',
      tooltip: 'Active users are users who opened at least one mandatory unit',
    },
    completedUsers: {
      label: 'Completed mandatory units',
    },
  },
};

export default value;
